import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const BriefcaseIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <g clip-path="url(#clip0_177447_14294)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.25 5.25H16.5V4.5C16.5 3.25736 15.4926 2.25 14.25 2.25H9.75C8.50736 2.25 7.5 3.25736 7.5 4.5V5.25H3.75C2.92157 5.25 2.25 5.92157 2.25 6.75V18.75C2.25 19.5784 2.92157 20.25 3.75 20.25H20.25C21.0784 20.25 21.75 19.5784 21.75 18.75V6.75C21.75 5.92157 21.0784 5.25 20.25 5.25ZM9 4.5C9 4.08579 9.33579 3.75 9.75 3.75H14.25C14.6642 3.75 15 4.08579 15 4.5V5.25H9V4.5ZM20.25 6.75V10.6509C17.7185 12.0289 14.8822 12.7505 12 12.75C9.11794 12.7505 6.28165 12.0292 3.75 10.6519V6.75H20.25ZM20.25 18.75H3.75V12.3413C6.31868 13.5977 9.1405 14.2506 12 14.25C14.8596 14.2501 17.6813 13.5969 20.25 12.3403V18.75ZM9.75 10.5C9.75 10.0858 10.0858 9.75 10.5 9.75H13.5C13.9142 9.75 14.25 10.0858 14.25 10.5C14.25 10.9142 13.9142 11.25 13.5 11.25H10.5C10.0858 11.25 9.75 10.9142 9.75 10.5Z"
          fill="#2E2E2E"
        />
      </g>
      <defs>
        <clipPath id="clip0_177447_14294">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BriefcaseIcon;
